import React from "react";
import Videos from "../components/Videos";
import LATEST from "../assets/backup/latest.json";

const LatestPage = () => {
	// *TODO: make api request
	return <Videos videos={LATEST} displayLatestPromo={true} />;
};
export default LatestPage;
